import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-xl-350px mb-10" }
const _hoisted_3 = { class: "card mb-5 mb-xl-8" }
const _hoisted_4 = { class: "card-body pt-15" }
const _hoisted_5 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_6 = {
  href: "#",
  class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1"
}
const _hoisted_7 = { class: "fs-5 fw-bold text-muted mb-2" }
const _hoisted_8 = { class: "flex-lg-row-fluid ms-lg-15" }
const _hoisted_9 = { class: "card mb-5 mb-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_avatar = _resolveComponent("avatar")!
  const _component_FeedsWidget2 = _resolveComponent("FeedsWidget2")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_avatar, {
              size: "80",
              fullname: _ctx.currentUser.nombreProveedor,
              color: "#005E8A"
            }, null, 8, ["fullname"]),
            _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.currentUser.nombreProveedor), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentUser.rutProveedor), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_FeedsWidget2, {
          "widget-classes": "mb-5 mb-xl-8",
          currentTicket: _ctx.currentTicket
        }, null, 8, ["currentTicket"]),
        _createVNode(_component_router_link, {
          to: { name: 'apps-my-tickets-listing' },
          class: "m-5 fs-6 fw-bolder"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Volver ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}